import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Typography } from '@material-ui/core'
import { setProfileMnaFilters } from 'reducers/profile/reducer'
import {
  FILTER_VIEW_DASHBOARD,
  FILTER_VIEW_SETTINGS,
} from 'constants/mnaFilters'
import LeftSidebar from './LeftSidebar'
import Content from './Content'
import SiteFilters from './SiteFilters'
import FiltersObserver from './FiltersObserver'
import 'styles/app/apps/monitors-and-alerts.scss'

class MonitorsAndAlerts extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isEditorActive: props.filterView === FILTER_VIEW_SETTINGS,
    }
  }

  onEditorToggle = () => {
    this.setState(
      prevState => ({
        isEditorActive: !prevState.isEditorActive,
      }),
      () => {
        this.props.setProfileMnaFilters({
          view: this.state.isEditorActive
            ? FILTER_VIEW_SETTINGS
            : FILTER_VIEW_DASHBOARD,
        })
      },
    )
  }

  render() {
    const { isEditorActive } = this.state
    const {
      currentApp: { name },
    } = this.props

    return (
      <div className="module ma-module">
        <div className="module-head">
          <Typography className="module-title" variant="h5">
            {name}
          </Typography>
          <SiteFilters />
          <FiltersObserver />
        </div>
        <div className="module-content ma-main">
          <LeftSidebar isEditorActive={isEditorActive} />
          <Content
            isEditorActive={isEditorActive}
            editorSwitcher={this.onEditorToggle}
          />
        </div>
      </div>
    )
  }
}

export default connect(
  state => ({
    filterView: state.getIn(['profile', 'mnaFilters', 'view']),
  }),
  {
    setProfileMnaFilters,
  },
)(MonitorsAndAlerts)
